import qs from 'qs'
import { createItemsData } from '../utils/request.utils'
import { QueueService } from './base-service'
import { HALApiService } from './hal-api.service'

/** GET/POST /storage/tasks/sequence — list sequences (filter by queue, state, etc.) */
export const pickingSequenceService = new QueueService('/storage/tasks/sequence', HALApiService, createItemsData, qs)
